import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'weekDayNames'
})
export class WeekDayNamesPipe implements PipeTransform {

    transform(start: Date, end: Date, showAsRange: boolean = true): string {
        const result: string[] = [];
        const current = start;
        while (current < end) {
            result.push(current.toLocaleString('en-US', {weekday: 'long'}));
            current.setDate(current.getDate() + 1);
        }
        if (showAsRange && (result.length > 2)) {
            return result[0] + ' - ' + result[result.length - 1];
        } else {
            return result.join(', ');
        }
    }

}
